module.exports = __webpack_public_path__ + "dbb700281141b856723ea6b35fa8bd0a.fbx";